import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { GENERATION_TOOL, isBlogWizardTemplateTool } from 'src/data/generationTool';
import { TEMPLATE_BUILDER_PARAMS } from 'src/data/template';
import { BLOG_WIZARD_LABEL } from 'src/data/ui';

import { customToolDataPropTypes } from '../../lib';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  generationTool: PropTypes.oneOf(Object.values(GENERATION_TOOL)),
  customToolData: customToolDataPropTypes,
};

const defaultProps = {
  className: '',
  generationTool: null,
  customToolData: null,
};

export const TemplateTag = ({ className, generationTool, customToolData }) => {
  const styles = useStyles();

  const title = getTemplateTitle({ generationTool, customToolData });

  if (!title) {
    return null;
  }

  return (
    <CustomTypography
      className={cx(className, styles.root)}
      variant={TYPOGRAPHY_VARIANT.medium12}
    >
      {title}
    </CustomTypography>
  );
};

TemplateTag.displayName = 'TemplateTypeTag';
TemplateTag.propTypes = propTypes;
TemplateTag.defaultProps = defaultProps;

// Only a card that works differently from the rest is named. A tag on every card tells the reader
// nothing.
const getTemplateTitle = ({ generationTool, customToolData }) => {
  if (isBlogWizardTemplateTool(generationTool)) {
    return BLOG_WIZARD_LABEL;
  }

  if (customToolData?.templateType === TEMPLATE_BUILDER_PARAMS.csv) {
    return 'CSV template';
  }

  return null;
};
